import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { FileText, AlertCircle } from 'lucide-react';
import { apiClient } from '../../utils/apiHelper';

const InventoryReturnReport = () => {
  const [returns, setReturns] = useState([]);
  const [summary, setSummary] = useState({ total: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => { fetchReport(); }, []);

  const fetchReport = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.get('/api/inventory/stock-issues');
      const issues = Array.isArray(response.data) ? response.data : [];
      const returned = issues.filter(i => i.return_date);
      setReturns(returned);
      setSummary({ total: returned.length });
    } catch (err) {
      console.error('Error:', err);
      setError('Failed to load return data. Please try again.');
      setReturns([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 space-y-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>Inventory Return Report</CardTitle>
          <Button onClick={fetchReport} disabled={loading}>
            <FileText className="w-4 h-4 mr-2" />{loading ? 'Loading...' : 'Refresh'}
          </Button>
        </CardHeader>
        <CardContent>
          {error && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2 text-red-700">
              <AlertCircle className="w-5 h-5" />
              <span>{error}</span>
              <Button variant="outline" size="sm" onClick={fetchReport} className="ml-auto">Retry</Button>
            </div>
          )}

          <div className="p-4 bg-green-50 rounded-lg mb-6">
            <p className="text-sm text-gray-600">Total Returns</p>
            <p className="text-2xl font-bold text-green-600">{summary.total}</p>
          </div>

          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b bg-gray-50">
                <th className="text-left p-3">Item</th>
                <th className="text-left p-3">Issued To</th>
                <th className="text-left p-3">Issue Date</th>
                <th className="text-left p-3">Return Date</th>
                <th className="text-left p-3">Quantity</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="5" className="text-center p-8 text-gray-500">Loading...</td></tr>
              ) : returns.length === 0 ? (
                <tr><td colSpan="5" className="text-center p-8 text-gray-500">No return records found</td></tr>
              ) : (
                returns.map((ret, idx) => (
                  <tr key={idx} className="border-b hover:bg-gray-50">
                    <td className="p-3 font-medium">{ret.item_name}</td>
                    <td className="p-3">{ret.issued_to}</td>
                    <td className="p-3">{ret.issue_date}</td>
                    <td className="p-3 text-green-600">{ret.return_date}</td>
                    <td className="p-3">{ret.quantity}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
};

export default InventoryReturnReport;
